import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
import './Achievements.css';

const Achievements = () => {
  const achievements = [
    {
      title: "TikTok Tech Jam 2024",
      description: "4th place and People's Choice winner in Australia across 4484 participants globally in TikTok’s hackathon for building TikPlayLive",
      link: "https://devpost.com/software/mmcandco",
    },
    {
      title: "Susquehanna International Group Algothon 2024",
      description: "2nd place across 600+ participants in Australia and New Zealand. Developed an algorithm to trade 50+ stocks across 1000+ days. Achieved a score of 609.35 based on PnL and volatility where the average of all teams was 279 and average outside of top 3 was 22",
      link: "/algothon",
    },
    {
      title: "MelbourneHack 2025",
      description: "Finalist in University of Melbourne’s hackathon amongst 77 participants",
      link: "https://devpost.com/software/lec-recall",
    },
    {
      title: "UNSW DevSoc HackaByte 2025",
      description: "Best UI/UX award across 86 participants for building an AI integrated course forum",
      link: "https://devpost.com/software/edbutbetter",
    },
    {
      title: "SYNCHack 2024",
      description: "Awarded “Best Pitch” for presentation in University of Sydney’s flagship hackathon from 46 teams for developing an app connecting users during Protests",
      link: "https://devpost.com/software/rallynow",
    },
    {
      title: "2024 DevSoc Blueprint Hackathon",
      description: "“Special Mention” in UNSW Software Dev Society's Hackathon for developing a personalized leetcode platform geared towards students from AU",
      link: "https://devpost.com/software/test-4i3b9q",
    },
    {
      title: "CalHacks Hack Month 2023",
      description: "Achieved 2nd place in UC Berkeley’s sustainability focused Hackathon for developing an iOS app to gamify sustainable habits",
      link: "https://www.instagram.com/p/Cup1sIMovwo/?igshid=MzRlODBiNWFlZA%3D%3D&img_index=3",
    },
  ];

  return (
    <section className="achievements-section">
      <div className="section-header">
        <h2 className="section-title">Highlights</h2>
      </div>
      <div className="achievements-list" style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem', maxWidth: '800px', margin: '0 auto' }}>
        {achievements.map((achievement, index) => (
          <motion.div 
            key={index} 
            className="achievement-item glass"
            style={{ padding: '2rem', borderRadius: '16px', position: 'relative', overflow: 'hidden' }}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ delay: index * 0.1, duration: 0.5, ease: "easeOut" }}
            whileHover={{ scale: 1.02, x: 10 }}
          >
            <a
              href={achievement.link}
              target={achievement.link.startsWith("http") ? "_blank" : "_self"}
              rel="noopener noreferrer"
              className="achievement-link"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.75rem', fontSize: '1.3rem', fontWeight: 700, color: 'var(--text-primary)', textDecoration: 'none' }}
            >
              <span style={{ backgroundImage: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                {achievement.title}
              </span> 
              <ExternalLink size={18} color="var(--primary-color)" />
            </a>
            <p className="achievement-description" style={{ color: 'var(--text-secondary)', fontSize: '1rem', lineHeight: 1.6, margin: 0 }}>
              {achievement.description}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Achievements;

